import React from 'react';
import MessagingContainer from './MessagingContainer';

class NewsScreen extends React.Component {

    public render() {
        return <MessagingContainer />
    }

}

export default NewsScreen;